import {IValidateBase} from "./IValidateBase";
import {IValidationResult} from "./IValidationResult";
import {Component} from "react";
import {store} from "../../redux/storeConfig/store";
import {dataUtils} from "../js/dataUtils";

export class AP_Validation_Email extends Component implements IValidateBase {
    validateCode = "AP_Validation_Email";
    validateName = "AP_Validation_Email";

    DefaultValues = {
        IsEnabled: false,
        ErrorMessage: "Title_EmailNotValid"
    }

    Validate =  (prmElement:any)=> {

        let outObj:IValidationResult = {
            isError: false,
            errorMessage:prmElement?.ExtendedParamsObj?.Validations?.AP_Validation_Email?.ErrorMessage || this.DefaultValues.ErrorMessage,
            ElementGuid: prmElement.ElementGuid,
        }

        if (!!prmElement?.ExtendedParamsObj?.Validations?.AP_Validation_Email?.IsEnabled) {
            let pageData = store.getState().store_PageData.data;
            let elementValue = dataUtils.getNestedJsonValue(pageData,prmElement.DataBindStr);

            if (!!elementValue){
                let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

                if (elementValue && !regex.test(elementValue)) {
                    outObj.isError = true;
                }
            }

        }

        return outObj;
    }

    ValidateValue =  (prmValue:any, prmParamsObj?:any)=> {
        let outObj:IValidationResult = {
            isError: false,
            errorMessage: this.DefaultValues.ErrorMessage,
            ElementGuid: '',
        }

        if (!!prmValue){
            let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

            if (prmValue && !regex.test(prmValue)) {
                outObj.isError = true;
            }
        }

        return outObj;
    }
}